import React from "react";

const DescriptionVisitingDoctor = () => {
  return (
    <div className="visitingdoc-container">
      <div className="visitingdoc-hero">
        <h1 className="visitingdoc-subtitle">Health Comes to You</h1>
        <h1 className="visitingdoc-title">
          Need a <span className="pinkhighlig">Visiting Doctor</span> for Your School, Office, or Factory?
        </h1>
      </div>

      <div className="visitingdoc-content">
        <p><strong>Looking for a doctor to visit your place for a day or on a regular basis?</strong></p>

        <p>
          On <strong>Dr Planete</strong>, schools, colleges, companies, and factories can post a request for a visiting doctor. This is helpful for regular check-ups, health camps, or workplace medical care.
        </p>

        <p><strong>You can post request for:</strong></p>
        
          <li><strong>General Physician (MD)</strong></li>
          <li><strong>Medical Officer (MBBS)</strong></li>
          <li><strong>Gynecologist</strong></li>
          <li><strong>Dentist</strong></li>
          <li><strong>Orthopedician</strong></li>

          <hr></hr>
        <p><strong>How It Works:</strong></p>
        
          <p>Post your request on <strong>Dr Planete</strong> in just a few steps.</p>
          <p>Doctors and hospitals who are part of <strong>Dr Planete</strong> will be notified.</p>
          <p>Interested doctors or hospitals will contact you directly if they are available.</p>
        
      </div>
    </div>
  );
};

export default DescriptionVisitingDoctor;

// CSS styles (in the same file)
const style = document.createElement("style");
style.innerHTML = `
  .visitingdoc-container {
    margin: 0 auto;
    width: 100%;
    font-family: 'Poppins', sans-serif;
  }

  .visitingdoc-hero {
    background: black;
    text-align: center;
    padding: 2rem 1rem;
    border-radius: 0px;
    margin-bottom: 2rem;
  }

  .visitingdoc-subtitle {
    color: black;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .visitingdoc-title {
    font-size: 45px;
    color: white;
    font-weight: 700;
  }

  .pinkhighlig {
    color: #FF4081;
  }

  .visitingdoc-content {
    font-size: 18px;
    line-height: 1.6;
    color: #333;
    padding: 0 1rem;
  }

  .visitingdoc-content ul,
  .visitingdoc-content ol {
    margin-left: 1.5rem;
    padding-left: 0.5rem;
  }

  .visitingdoc-content li {
    margin-bottom: 0.5rem;
  }

  @media (max-width: 768px) {
    .visitingdoc-title {
      font-size: 36px;
    }

    .visitingdoc-subtitle {
      font-size: 20px;
    }

    .visitingdoc-content {
      font-size: 19px;
    }
  }
`;
document.head.appendChild(style);
